<template>
  <div class="mb-4 mx-4">
    <div class="background">
      <div class="row">
        <div class="mx-0 pa-0 logo">
          <img src="@/assets/sze_logo.png" class="logo" />
        </div>
        <div v-if="title_ne != null || title_ne != undefined" class="mx-auto header-user-details">
          <p class="header_p">
            <b>{{ title_ne }}: </b>{{ title }}
          </p>
          <p class="header_p">
            <b>{{ title_na }}: </b>{{ title_2 }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    title_2: String,
    title_na: String,
    title_ne: String,
  },
  mounted() {
  },
};
</script>

<style >
.background {
  width: 80%;
  margin: auto;
  display: flex;
}
.fontsize {
  font-size: 1.5rem;
}
.logo {
  width: min(50vw, 400px);
}
.row {
  display: flex;
}
.header_p {
  font-size: 1.1rem;
  font-weight: 200;
  margin: 0 !important;
  padding: 0;
}

@media (max-width: 1279px) {
  .logo {
    width: 80%;
    margin: 0 !important;
    padding: 0 !important;
  }
  .background {
    width: 100%;
  }
  .logo {
    max-width: 400px;
  }
}
</style>